import React, { useState } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { isNullOrUndefined } from "../util/HelperUtil";
import { useSnackbar } from "notistack";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";
import { CircularProgress } from "@mui/material";

const generatePeriods = (project) => {
  const totalPeriods = project.rootTaskPackage.plannedProgress.length;
  return [...Array(totalPeriods).keys()].map((p) => p + 1);
};

const DialogRebaseline = ({ open, onCancel, classes, task, project }) => {
  let periods = generatePeriods(project);

  const { enqueueSnackbar } = useSnackbar();
  const [loadingPrebaseline, setloadingPrebaseline] = useState(false);
  const [baselineStarted, setBaselineStarted] = useState(false);
  const [baselineCompleted, setBaselineCompleted] = useState(false);
  const [selectedPeriod, setselectedPeriod] = useState(periods[0]);
  const [baselineDescription, setBaselineDescription] = useState("");

  let prebaselinedPeriods = Math.max.apply(
    Math,
    project.getUnarcPrebaselinePeriods(setloadingPrebaseline)
  );

  const handleSelectedPeriod = (event) => {
    setselectedPeriod(event.target.value);
  };

  const handleBaselineDescription = (event) => {
    setBaselineDescription(event.target.value);
  };

  const handleConfirm = () => {
    setBaselineStarted(true);
    project.rebaseline(
      selectedPeriod,
      baselineDescription,
      setBaselineCompleted,
      () => {
        project.updatePrebaselinePeriods(setloadingPrebaseline, () => {
          project.updateProjectInfo(
            {
              name: project.name,
              folderName: project.folderName,
              ownerName: project.ownerName,
            },
            enqueueSnackbar
          );
        });
      }
    );
    onCancel();
    if (
      !isNullOrUndefined(task.distribution) &&
      !isNullOrUndefined(task.distribution.code)
    ) {
      task.applyDistribution(task.distribution.code);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setBaselineStarted(false);
    setBaselineCompleted(false);
    setloadingPrebaseline(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onCancel}
        aria-labelledby="form-dialog-title"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">Rebaseline</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            Period new baseline comes into effect:
          </DialogContentText>
          <FormControl >
            <InputLabel id="rebaseline-period-select-label">Period</InputLabel>
            <Select
              labelId="rebaseline-period-select-label"
              id="rebaseline-period-select"
              value={selectedPeriod}
              onChange={handleSelectedPeriod}
            >
              {periods.map((p) =>
                p > prebaselinedPeriods ? (
                  <MenuItem key={p} value={p}>{`Period ${p}`}</MenuItem>
                ) : (
                  <MenuItem key={p} value={p}>{`Period ${p}*`}</MenuItem>
                )
              )}
            </Select>
            <TextField
              id="filled-basic"
              label="Baseline's Description"
              variant="standard"
              value={baselineDescription}
              onChange={handleBaselineDescription}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="secondary">
            Close
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        title="Rebaseline Started"
        open={baselineStarted}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          Started Rebaselining...
        </Alert>
      </Snackbar>
      <Snackbar
        title="Rebaseline Successul"
        open={baselineCompleted}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Successfully Rebaselined!
        </Alert>
      </Snackbar>
      <Snackbar
        title="Load Prebaseline Message"
        open={loadingPrebaseline}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          <div>
            <CircularProgress color="inherit" />
            Please wait while the baseline snapshot is being generated, this may
            take several minutes
          </div>
        </Alert>
      </Snackbar>
    </div>
  );
};

DialogRebaseline.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default observer(DialogRebaseline);
